"use strict";

define('service/decision',['require','exports','module','appkit/service','../collection/assignments','../model/board.member','../model/document.decision.type','../model/document.decision.category','../model/document.letter','../model/setting','../view/decision.detail','../view/decision.detail.summary'],function (require, exports, module) {
  var Service = require('appkit/service'),
    Assignments = require('../collection/assignments'),
    BoardMember = require('../model/board.member'),
    DocumentDecisionType = require('../model/document.decision.type'),
    DocumentDecisionCategory = require('../model/document.decision.category'),
    DocumentLetter = require('../model/document.letter'),
    Setting = require('../model/setting'),
    DecisionDetailView = require('../view/decision.detail'),
    DecisionDetailSummaryView = require('../view/decision.detail.summary');
  var DecisionService = Service.extend({
    inject: [],
    events: {
      authenticated: 'onAuthenticated'
    },
    replies: {
      decisionDetails: 'buildDecisionDetails',
      decisionDetailsOverlay: 'decisionDetailsWithOverlay'
    },
    onAuthenticated: function onAuthenticated(user) {
      this.currentUser = user.person;
    },
    isResponsiblePerson: function isResponsiblePerson(decision) {
      return decision.get('responsiblePersonId') == this.currentUser.id;
    },
    isDecisionFinalized: function isDecisionFinalized(decision) {
      return !!decision.get('finalizedDate');
    },
    isDecisionEditable: function isDecisionEditable(decision, options) {
      return !decision.get('finalizedDate') && this.isResponsiblePerson(decision);
    },
    isDecisionEditableByPermission: function isDecisionEditableByPermission(decision) {
      return !decision.get('finalizedDate') && decision.get('type') == 'FULL' && this.currentUser.hasPermission('IRB_MODIFY_FULL_DECISION');
    },
    isSubDecisionEditable: function isSubDecisionEditable(decision) {
      return !decision.get('subDecisionFinalizedDate') && this.currentUser.hasRole('IRB_ANALYST') && !decision.get('parentId');
    },
    editDecisionDependencies: function editDecisionDependencies(decision) {
      var reviewOrDecisionType = this.request('decision:query', decision.get('decisionType'), decision.get('type'));
      var policyName = decision.get('policyName');
      var options = {
        assignments: new Assignments().params({
          entityType: 'document',
          entityId: decision.get('document').get('id')
        }),
        boardMembers: BoardMember.members(),
        categories: DocumentDecisionCategory.all(decision.get('id'), reviewOrDecisionType, policyName),
        decisionTypes: DocumentDecisionType.all(decision.get('document').get('id')),
        settings: Setting.all(['IRB.DEFAULT_STUDY_EXPIRATION_INTERVAL']),
        policyName: policyName,
        reviewType: decision.get('type')
      };
      return Promise.join(options.assignments.fetch(), options.categories.fetch(), options.decisionTypes.fetch(), options.settings.fetch()).then(function () {
        var board = options.assignments.getByAssignmentTypeDescription('IRB_BOARD').models[0];
        if (board) {
          options.boardMembers.params({
            id: board.get('group').get('id')
          });
          return options.boardMembers.fetch();
        }
      }).thenReturn(options);
    },
    editSubDecisionDependencies: function editSubDecisionDependencies(decision) {
      var options = {
        assignments: new Assignments().params({
          entityType: 'document',
          entityId: decision.get('document').get('id')
        }),
        boardMembers: BoardMember.members()
      };
      return Promise.join(options.assignments.fetch()).then(function () {
        var board = options.assignments.getByAssignmentTypeDescription('IRB_BOARD').models[0];
        if (board) {
          options.boardMembers.params({
            id: board.get('group').get('id')
          });
          return options.boardMembers.fetch();
        }
      }).thenReturn(options);
    },
    finalizedDecisionDependencies: function finalizedDecisionDependencies(decision) {
      var options = {
        letters: DocumentLetter.allByDecisionId(decision.get('id'))
      };
      return Promise.join(options.letters.fetch()).thenReturn(options);
    },
    buildDecisionDetails: function buildDecisionDetails(options) {
      var decision = options ? options.model : null,
        app = this.app;
      options = options || {};
      var decisionEditable = this.isDecisionEditable(decision) || !!(options.allowPermissions && this.isDecisionEditableByPermission(decision)),
        subDecisionEditable = this.isSubDecisionEditable(decision);
      options.editable = decisionEditable || subDecisionEditable;
      if (!decision) {
        throw new Error('There is no available decision.');
      }
      if (decisionEditable) {
        return this.editDecisionDependencies(decision).then(function (opts) {
          opts.app = app;
          opts.model = decision;
          return new DecisionDetailView(opts);
        });
      } else if (subDecisionEditable) {
        return this.editSubDecisionDependencies(decision).then(function (opts) {
          opts.app = app;
          opts.model = decision;
          return new DecisionDetailView.SubDecision(opts);
        });
      } else if (this.isDecisionFinalized(decision)) {
        return this.finalizedDecisionDependencies(decision).then(function (opts) {
          opts.app = app;
          opts.model = decision;
          return new DecisionDetailSummaryView(opts);
        });
      } else {
        return new DecisionDetailSummaryView({
          model: decision
        });
      }
    },
    decisionDetailsWithOverlay: function decisionDetailsWithOverlay(options) {
      var channel = this.channel,
        events = _.extend({}, Backbone.Events);
      options = options || {};
      Promise.resolve(this.buildDecisionDetails(options)).then(function (view) {
        _.defer(function () {
          var overlay = channel.request('show:singleModelDependentOverlay', view, options);
          events.listenToOnce(overlay, 'hidden', function () {
            events.stopListening(overlay);
            events.trigger('hidden');
          });
        });
        return events;
      })["finally"](channel.request('dimmer'));
      return events;
    }
  });
  module.exports = DecisionService;
});

